import Blaze from "@swiggy-private/blaze.js";
import { Storage } from "@swiggy-private/core-ui";

export const recordCartPercievedTime = (cartLoadEventName: string, appLoadTimeEventName: string): void => {
    // Record load time metric for single instance in session,
    // to prevent falsy metrics be populated which navigating back from history (payments => dineout-cart)
    const isFirstLoad = Storage.getItem("hasDineoutCartLoadTimeRecorded") !== "true";
    if (isFirstLoad) {
        Blaze.recordTimeFromAppStart(appLoadTimeEventName);
        Storage.setItem("hasDineoutCartLoadTimeRecorded", "true");
    }

    Blaze.recordEnd(cartLoadEventName);
};
